export default {
	NO_TASKS: 'No tasks for this workplace',
	LOAD_PREVIOUS_TASKS: 'Load previous tasks'
};
